export default "__VITE_ASSET__81c04fab__"